<template>
  <v-autocomplete
    id="consultant-select"
    v-model="selectedValue"
    item-text="nome"
    item-name="usuarioId"
    item-value="usuarioId"
    :items="users"
    :label="
      !this.isAT || this.$store.state.uf === 'MA'
        ? this.consultorValue || 'Responsável'
        : this.isAT
        ? 'ATS'
        : 'Consultor'
    "
    :placeholder="consultorLabel"
    :multiple="isMultiple"
    :return-object="returnObject"
    clearable
    @change="handleChange"
  >
    <template slot="no-data"> Nenhum usuário retornado </template>
  </v-autocomplete>
</template>

<script>
import { userAPI } from "./UserAPI";
import { mapGetters } from "vuex";

export default {
  name: "AppConsultantCombobox",
  props: ["filter", "consultorValue", "isMultiple", "returnObject"],
  mounted() {
    this.loadConsultant();
    this.initializeValue();
  },
  computed: {
    ...mapGetters(["isAT"]),
  },
  watch: {
    filter: {
      handler(newFilter) {
        if (newFilter && newFilter.usuarioId !== this.selectedValue) {
          this.selectedValue = newFilter.usuarioId;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    initializeValue() {
      if (this.filter && this.filter.usuarioId !== undefined) {
        this.selectedValue = this.filter.usuarioId;
      }
    },
    handleChange(value) {
      // Emite evento para o pai
      this.$emit("change", value);

      // Atualiza o filter para manter compatibilidade
      if (this.filter) {
        this.$set(this.filter, "usuarioId", value);
      }
    },
    loadConsultant() {
      userAPI
        .list()
        .then((resp) => {
          this.users = resp.data.filter((item) => item.habilitado);
        })
        .catch((resp) => {
          this.$notification.error("Erro ao obter usuários");
        });
    },
  },
  data() {
    return {
      users: [],
      consultorLabel: "Consultor",
      selectedValue: null,
    };
  },
};
</script>
